"use strict";exports.stringEndsWith=function(t,n){var e=t.length;return t.slice(e-n.length,e)===n};
//# sourceMappingURL=stringEndsWith.cjs.map
